module.exports = ":host ::ng-deep .hrcl-informatic-message {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  right: 0;\n  z-index: 99; }\n  :host ::ng-deep .hrcl-informatic-message .ui-messages {\n    margin: 0; }\n  @media (max-width: 1024px) {\n  :host ::ng-deep .hrcl-informatic-message {\n    position: relative;\n    top: 0px;\n    left: 0;\n    right: 0;\n    z-index: 99; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/informatic-messages/informatic-messages.component.scss
// module id = ./src/app/admission/informatic-messages/informatic-messages.component.scss
// module chunks = main